import Tab from '../lib/Tab';
import Modal from '../lib/Modal';
import Close from '../lib/Close';
import scroller from './v1Scroller';

// タブのカレントクラスを制御する共通関数
function setCurrentTab(currentHref) {
  // 全てのタブアイテムから -current クラスを削除
  const tabItems = document.querySelectorAll(
    '.v1-seasons-tabs__tabList.-foot .v1-seasons-tabs__tabItem',
  );
  tabItems.forEach(item => {
    item.classList.remove('-current');
  });

  // 指定されたタブアイテムに -current クラスを追加
  const newCurrentItem = document
    .querySelector(`.v1-seasons-tabs__tabList.-foot [href="${currentHref}"]`)
    .closest('.v1-seasons-tabs__tabItem');
  newCurrentItem.classList.add('-current');
}

export default function v1Seasons() {
  if (!document.querySelector('.v1-seasons-tabs')) {
    return;
  }

  const tab = new Tab({
    afterClick: event => {
      scroller.to('.v1-seasons-tabs');

      // クリックされたタブのhref属性を取得
      const href = event.target.getAttribute('href');

      // タブのカレントクラスを制御する
      setCurrentTab(href);
    },
  });
  tab.init();

  const footTabs = document.querySelectorAll('.v1-seasons-tabs__tabList.-foot');
  footTabs.forEach(footTab => {
    footTab.addEventListener('click', event => {
      // クリックされたタブのhref属性を取得
      const href = event.target.closest('.v1-seasons-tabs__tabLink').getAttribute('href');

      // タブのカレントクラスを制御する
      setCurrentTab(href);

      // 対象のタブをクリックする
      const tabLink = document.querySelector(`[href="${href}"].js-tabs-link`);
      tabLink.click();
      tabLink.focus();
      event.preventDefault();
    });
  });

  function checkScroll() {
    // 監視する要素を取得
    const imageArea = document.querySelector('.v1-seasons-tabs__contentMainImageArea');

    // スクロール可能かどうかをチェック
    if (imageArea.scrollWidth > imageArea.clientWidth) {
      // 横スクロール可能なら `-scrolled` クラスを追加
      imageArea.classList.add('-scrolled');
    } else {
      // 横スクロールしていなければ `-scrolled` クラスを削除
      imageArea.classList.remove('-scrolled');
    }
  }
  window.addEventListener('load', checkScroll);
  window.addEventListener('resize', checkScroll);

  const trigger = document.querySelectorAll('.js-modal-trigger-area1');

  const modalHTML = number => {
    return `
      <div class="v1-dialog${number}" id="js-modal-area${number}">
        <div class="v1-dialog${number}__content" id="js-modal-focus-area${number}" role="dialog" aria-modal="true" tabindex="-1">
          <div class="v1-dialog${number}__inner">
            <div class="v1-dialog${number}__headActions sticky">
              <button class="v1-dialog${number}__close js-modal-close-area${number}">
                <svg class="v1-dialog${number}__closeIcon" role="img" aria-label="${Close.text()}" focusable="false">
                  <use xlink:href="/japan-travel-planner/common/svg/sprite.svg#close">
                </svg>
              </button>
            </div>
            <div class="v1-dialog${number}__cloneContent" id="js-modal-content-area${number}"></div>
            <div class="v1-dialog3__footActions">
              <button type="button" class="js-modal-close-area${number} v1-button v1-dialog${number}__button">${Close.text()}</button>
            </div>
          </div>
        </div>
        <div class="v1-dialog${number}__overlay" id="js-modal-overlay-area${number}"></div>
      </div>
    `;
  };

  window.addEventListener('DOMContentLoaded', () => {
    if (trigger.length) {
      document.getElementsByTagName('body')[0].insertAdjacentHTML('beforeend', modalHTML(1));
      document.getElementsByTagName('body')[0].insertAdjacentHTML('beforeend', modalHTML(2));
      document.getElementsByTagName('body')[0].insertAdjacentHTML('beforeend', modalHTML(3));
      document.getElementsByTagName('body')[0].insertAdjacentHTML('beforeend', modalHTML(4));
    }
  });

  window.addEventListener('load', () => {
    if (trigger.length) {
      const modal1 = new Modal({
        trigger: '.js-modal-trigger-area1',
        cloneContent: '.js-modal-clone-area1',
        closeButton: '.js-modal-close-area1',
        modal: 'js-modal-area1',
        content: 'js-modal-content-area1',
        focus: 'js-modal-focus-area1',
        overlay: 'js-modal-overlay-area1',
      });
      const modal2 = new Modal({
        trigger: '.js-modal-trigger-area2',
        cloneContent: '.js-modal-clone-area2',
        closeButton: '.js-modal-close-area2',
        modal: 'js-modal-area2',
        content: 'js-modal-content-area2',
        focus: 'js-modal-focus-area2',
        overlay: 'js-modal-overlay-area2',
      });
      const modal3 = new Modal({
        trigger: '.js-modal-trigger-area3',
        cloneContent: '.js-modal-clone-area3',
        closeButton: '.js-modal-close-area3',
        modal: 'js-modal-area3',
        content: 'js-modal-content-area3',
        focus: 'js-modal-focus-area3',
        overlay: 'js-modal-overlay-area3',
      });
      const modal4 = new Modal({
        trigger: '.js-modal-trigger-area4',
        cloneContent: '.js-modal-clone-area4',
        closeButton: '.js-modal-close-area4',
        modal: 'js-modal-area4',
        content: 'js-modal-content-area4',
        focus: 'js-modal-focus-area4',
        overlay: 'js-modal-overlay-area4',
      });
      modal1.init();
      modal2.init();
      modal3.init();
      modal4.init();
    }
  });
}
